const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`, `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`, 1, 100), new Map([[`class`, `o-rhythm--generous`]]), true, false, 1));
            }

            getTemplateName() {
                return `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`, ``);
            }
        }],
        [100, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h1>t-`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`theme`) ? context.get(`theme`) : null), `html`, null, true]));
                this.echo(`</h1>
    `);
                this.echo(this.include(context, this.source, `@cloudfour/design/demo/theme-content.twig`, undefined, false, false, 6));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/demo/styles.twig`, undefined, false, false, 7));
                this.echo(`    `);
                context.proxy[`_card_class`] = `c-card--horizontal@m c-card--contained`;
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/card/demo/single.twig`, new Map([[`class`, (context.has(`_card_class`) ? context.get(`_card_class`) : null)], [`href`, `#`], [`show_heading`, true], [`show_content`, true], [`show_cover`, true], [`show_footer`, true]]), false, false, 9));
                this.echo(`    `);
                if (this.compare((context.has(`theme`) ? context.get(`theme`) : null), `light`)) {
                    this.echo(`      `);
                    context.proxy[`_card_class`] = ((context.has(`_card_class`) ? context.get(`_card_class`) : null) + ` t-dark`);
                    this.echo(`    `);
                }
                else {
                    this.echo(`      `);
                    context.proxy[`_card_class`] = ((context.has(`_card_class`) ? context.get(`_card_class`) : null) + ` t-light`);
                    this.echo(`    `);
                }
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/card/demo/single.twig`, new Map([[`class`, (context.has(`_card_class`) ? context.get(`_card_class`) : null)], [`href`, `#`], [`show_heading`, true], [`show_content`, true], [`show_cover`, true], [`show_footer`, true]]), false, false, 22));
                this.echo(`  `);
            }

            getTemplateName() {
                return `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7');

let template = env.loadTemplate('ef172eb44319e2ebd97fe0655b06b02705806d764f96196e6664f21f6cc1ddb7');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/design/demo/theme.twig", args: context }
     );
     return rendered;;
};